// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ff31963f","732":"810bb68c","977":"16ec5d1d"}[chunkId] + ".chunk.js";
};